import React from "react";
import "./Tooltip.css";

const PREMIUM_UPGRADE_MESSAGE =
  "Contact us at example@example.com to upgrade to Premium";

const Tooltip = ({ text, children }) => {
  return (
    <div className="tooltip-container">
      {children}
      <span className="tooltip-text">{text || PREMIUM_UPGRADE_MESSAGE}</span>
    </div>
  );
};

export default Tooltip;
